/** Small, fast, non-cryptographic hash for cue dismissal-suppression keys (spec 046 SC-009). */
export function simpleHash(text: string): string {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = (Math.imul(31, hash) + text.charCodeAt(i)) | 0;
  }
  return hash.toString(36);
}
